// extracted by mini-css-extract-plugin
export default {"depositAndWithdrawal":"DepositWithdrawModal_depositAndWithdrawal__RUJuy"};